class SizeChart extends HTMLElement {
  constructor() {
    super();
    // this.isAttribute = this.getAttribute('is');
    this.addEventListener('click', this.initSizeChart.bind(this));
  }

  initSizeChart(event) {
    event.preventDefault();

    // Find all dialog elements
    // const dialogs = document.querySelectorAll('dialog');
    const drawers = document.querySelectorAll('marmeto-drawer');
    let matchedDrawer = null;

    // Match the is attribute with the id of the dialog elements
    drawers.forEach(drawer => {

      this.anchor = this.querySelector('a').getAttribute('data-chart');

      const dialog = drawer.querySelector('dialog');

      if (dialog.id === this.anchor) {
        matchedDrawer = drawer;
      }
    });

    // Call openDialog if a matching dialog is found
        
    if (matchedDrawer && matchedDrawer.openDialog) {
      matchedDrawer.openDialog();
    } else {
      console.error('Matching dialog element or openDialog method not found');
    }
  }
}

// Define the custom element
customElements.define('size-chart', SizeChart);